import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import PPNAPPFeatures from "./PPNAPPFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";

// Main component for PPN App
export default function PPNAPP() {
  // Overview data
  const data1 = [
    "Contract Manufacturing Services: Optimizes production and supply chain management.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["PPN APP"]}
        DownloadText="Download App"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.ppnapp"
        DlBtn="true"
      />

      {/*  Overview  Section*/}
      <SolutionEcosystem title="Overview" type="PPN" />

      {/*  Overview Feature Section*/}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>

      {/* Features & Benefits Section*/}
      <PPNAPPFeatures />
      <APPBenefit />
    </>
  );
}
